import React from 'react'

import {
  TimeGatedShipmentNotificationBar,
} from '@Components/ShipmentNotificationBar'
import { useTranslation } from '@Globals/Translations'

const startDate = new Date('Thu May 12 2022 16:00:00 GMT+0200 (Central'
  + ' European Summer Time)')
const endDate = new Date('Fri May 13 2022 16:00:00 GMT+0200 (Central European'
  + ' Summer Time)')

export const DelayWarningBar = () => {
  const { t } = useTranslation()

  return (
    <TimeGatedShipmentNotificationBar
      background="primary"
      color="white"
      endDate={endDate}
      startDate={startDate}
    >
      {t('header:HOLIDAY_1_DAY_DELAY_IN_ADVANCE')}
    </TimeGatedShipmentNotificationBar>
  )
}
